<template>
  <el-form-item :label="title">
    <el-select
      v-model="value"
      filterable
      remote
      :placeholder="placeholder"
      :remote-method="handleQuery"
      :loading="loading"
      :disabled="disabled"
      :style="{width: width + 'px'}"
      :class="itemClass"
    >
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { parse, save } from '../providers/store-parser'

export default {
  name: 'InputSelectRemoteSuggestion',
  data () {
    return {
      options: [],
      loading: false
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    query: {
      type: Function,
      required: true
    },
    getter: {
      type: String,
      required: true
    },
    setter: {
      type: String,
      required: true
    },
    watcher: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    isRequire: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '140'
    },
    itemClass: {
      type: String,
      default: ''
    },
    needBus: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    value: {
      get () {
        return parse(this.getter)
      },
      set (val) {
        const item = this.options.find(o => o.value === val).data || {}
        if (this.needBus) {
          save(this.setter, item, this.bus)
        } else {
          save(this.setter, item)
        }
      }
    },
    watchAt () {
      if (this.watcher !== '') {
        return parse(this.watcher)
      } else {
        return ''
      }
    }
  },
  methods: {
    async handleQuery (queryString) {
      if (queryString !== '') {
        this.loading = true
        this.options = await this.query(queryString)
        this.loading = false
      }
    }
  },
  watch: {
    watchAt: function (val) {
      // console.log(val)
      this.$emit('select-changed', val)
    }
  },
  inject: ['bus']
}
</script>
